import { useState } from "react";
import { Expand } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { ArticleImage } from "./ArticleCard";

const Credit = ({ text }) => (text ? <span className="absolute bottom-2.5 right-2.5 rounded-md bg-white/85 px-2 py-0.5 text-[11px] font-medium text-slate-700 backdrop-blur-sm">{text}</span> : null);

export const ArticleFigure = ({ b, i }) => (
  <figure className={`my-10 ${b.wide ? "lg:-mx-16" : ""}`} data-testid={`kb-block-image-${i}`}>
    <div className="relative aspect-[3/2] overflow-hidden rounded-2xl bg-slate-100">
      <ArticleImage image={b.image} sizes={b.wide ? "(min-width: 1024px) 860px, calc(100vw - 32px)" : "(min-width: 1024px) 720px, calc(100vw - 32px)"} />
      <Credit text={b.image.credit} />
    </div>
    {b.caption && <figcaption className="mt-3 text-[14px] leading-relaxed text-slate-500">{b.caption}</figcaption>}
  </figure>
);

export const ArticleGallery = ({ b, i }) => {
  const [open, setOpen] = useState(null);
  const n = b.images.length;
  return (
    <figure className="my-10" data-testid={`kb-block-gallery-${i}`}>
      <ul className={`grid gap-3 ${n === 1 ? "" : n === 2 || n === 4 ? "grid-cols-2" : "grid-cols-2 sm:grid-cols-3"}`}>
        {b.images.map((img, j) => (
          <li key={img.path + j}>
            <button type="button" onClick={() => setOpen(img)} className="group relative block aspect-[4/3] w-full overflow-hidden rounded-xl bg-slate-100"
              aria-label={`Vergroot: ${img.alt || "afbeelding"}`} data-testid={`kb-gallery-${i}-open-${j}`}>
              <ArticleImage image={img} sizes="(min-width: 1024px) 240px, 50vw" className="transition-transform duration-500 group-hover:scale-[1.03]" />
              <span className="absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-full bg-white/85 text-ink opacity-0 transition-opacity group-hover:opacity-100"><Expand className="h-4 w-4" aria-hidden="true" /></span>
              <Credit text={img.credit} />
            </button>
          </li>
        ))}
      </ul>
      {b.caption && <figcaption className="mt-3 text-[14px] leading-relaxed text-slate-500">{b.caption}</figcaption>}
      <Dialog open={Boolean(open)} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="max-w-5xl border-0 bg-transparent p-0 shadow-none" data-testid={`kb-gallery-${i}-lightbox`}>
          <DialogTitle className="sr-only">{open?.alt || "Afbeelding"}</DialogTitle>
          {open && <ArticleImage image={open} sizes="100vw" className="max-h-[85vh] rounded-xl object-contain" />}
        </DialogContent>
      </Dialog>
    </figure>
  );
};
